
import Vue from "vue";
import AppProductTaxesEditFostplus from "@/components/settings-default/ProductTaxesEditFostplus.vue";
import { IBreadCrumb } from "winfakt-vue-components";

export default Vue.extend({
	computed: {
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{to: "/settings/products", value: this.$ct("products")},
				{value: this.$ct("taxes")}
			] as IBreadCrumb[];
		},
	},
	components: {
		AppProductTaxesEditFostplus
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
